import { useTheme } from "@emotion/react";
import {
  Box,
  Chip,
  Grid,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
  Button,
  useMediaQuery,
  ClickAwayListener,
} from "@mui/material";
import React, { useState } from "react";

const RfqToCcSectionForNonEntity = ({
  businessName,
  isSmallScreen,
  newCcEmails,
  setNewCcEmails,
  handleChange,
  values,
  errors,
  touched,
  handleOnBlur,
}) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"), {
    defaultMatches: true,
  });

  const [openAddEmailDoalog, setOpenAddEmailDoalog] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [showMoreAllAddedEmails, setShowMoreAllAddedEmails] = useState(false);
  const [expandCcList, setExpandCcList] = useState(true);

  const handleClickAwayCcList = () => {
    setExpandCcList(false);
  };
  const addEmailOnclick = () => {
    setOpenAddEmailDoalog(true);
  };
  const handleShowAddedEmails = () => {
    // setShowMoreAllAddedEmails(true);
    setExpandCcList(true);
  };
  const handleDeleteNewCcEmails = (emailData) => {
    setNewCcEmails((preVal) => preVal.filter((email) => email !== emailData));
  };
  const handleCloseAddEmailDoalog = () => {
    setOpenAddEmailDoalog(false);
  };
  const handleCloseAddedEmails = () => {
    setShowMoreAllAddedEmails(false);
  };
  const validateEmail = (email) => {
    const validationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = validationRegex.test(email) &&
        !/\.(com|in)[^a-zA-Z0-9]/.test(email) &&
        !/\.{2,}/.test(email) &&
        !/\.,com$/.test(email);

    return isValid;
  };

  const handleAddEmail = () => {
    if (validateEmail(newEmail)) {
      setNewCcEmails([...newCcEmails, newEmail]);
      setNewEmail("");
      setEmailError(false);
      setOpenAddEmailDoalog(false);
    } else {
      setEmailError(true);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAddEmail();
    }
  };
  return (
    <>
      

      <Grid
        padding="6px 0px 10px"
        gap={isSmallScreen ? "8px" : "0"}
        borderBottom={"1px #CFDAE5 solid"}
        display={"flex"}
        flexWrap={"wrap"}
        alignItems="baseline"
      >
        <Typography sx={{ color: "#4C4C4C" }}>Subject: </Typography>
        <Grid display={"flex"} flexWrap={"wrap"}>
          <TextField
            sx={{ ml: "11px", width: "237px" }}
            variant="standard"
            name="name"
            required
            id="name"
            // placeholder="Label"
            onChange={handleChange}
            onBlur={() => handleOnBlur("name", values.name)}
            inputProps={{ maxLength: 100 }}
            value={values.name}
            error={Boolean(touched.name && errors.name)}
            helperText={touched.name && errors.name}
          />
        </Grid>
      </Grid>

      <Dialog
        open={openAddEmailDoalog}
        onClose={handleCloseAddEmailDoalog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Add Email To CC</DialogTitle>
        <DialogContent>
          <DialogContentText>Add one email at a time</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            value={newEmail}
            error={emailError}
            helperText={emailError ? "Please enter a valid email" : ""}
            onKeyDown={handleKeyDown}
            onChange={(e) => setNewEmail(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddEmailDoalog}>Cancel</Button>
          <Button onClick={handleAddEmail}>Add</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={showMoreAllAddedEmails}
        onClose={handleCloseAddedEmails}
      >
        <DialogContent>
          {newCcEmails?.map((email) => (
            <Chip
              size="small"
              label={email}
              variant="outlined"
              onDelete={() => handleDeleteNewCcEmails(email)}
              sx={{
                maxWidth: !isSm ? "170px" : "auto",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                margin: "4px",
              }}
            />
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddedEmails}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RfqToCcSectionForNonEntity;
